import React, { useRef, useState, useEffect } from "react";
import Pickr from "@simonwep/pickr";
import "@simonwep/pickr/dist/themes/monolith.min.css"; // Подключите нужную тему

function ColorPicker(props) {
    const { onColorChange } = props.onColorChange;
    const { titleSave, titleClear, titleCopied } = props.attributes;
    const [format, setFormat] = useState("HEXA"); // По умолчанию HEXA
    const [showMessage, setShowMessage] = useState(false); // Для отображения "Copied!"

    const pickrContainer = useRef(null);

    useEffect(() => {
        requestAnimationFrame(() => {
            if (pickrContainer.current) {
                const pickr = Pickr.create({
                    el: pickrContainer.current,
                    inline: true,
                    theme: "monolith", // Тема может быть изменена на другую
                    /* appClass: "pickr-custom-class", */
                    /* container: document.querySelector(
                        ".color-picker-container"
                    ), */
                    default: "rgb(255,255,255)",
                    showAlways: true,
                    swatches: [
                        "rgba(244, 67, 54, 1)",
                        "rgba(233, 30, 99, 0.95)",
                        "rgba(156, 39, 176, 0.9)",
                        "rgba(103, 58, 183, 0.85)",
                        "rgba(63, 81, 181, 0.8)",
                        "rgba(33, 150, 243, 0.75)",
                    ],
                    components: {
                        preview: true,
                        opacity: true,
                        hue: true,
                        interaction: {
                            hex: true,
                            rgba: true,
                            hsla: true,
                            hsva: true,
                            cmyk: true,
                            input: true,
                            clear: true,
                            save: true,
                        },
                    },

                    i18n: {
                        // Strings visible in the UI
                        "ui:dialog": "color picker dialog",
                        "btn:toggle": "toggle color picker dialog",
                        "btn:swatch": "color swatch",
                        "btn:last-color": "use previous color",
                        "btn:save": titleSave,
                        "btn:cancel": "Cancel",
                        "btn:clear": titleClear,

                        // Strings used for aria-labels
                        "aria:btn:save": "save and close",
                        "aria:btn:cancel": "cancel and close",
                        "aria:btn:clear": "clear and close",
                        "aria:input": "color input field",
                        "aria:palette": "color selection area",
                        "aria:hue": "hue selection slider",
                        "aria:opacity": "selection slider",
                    },
                });

                pickr.on("change", (color, instance) => {
                    setFormat(instance._representation); // Отслеживаем текущий выбранный формат
                });

                /* pickr.on("save", (color, instance) => {
            onColorChange && onColorChange(color.toRGBA().toString());
            pickr.hide();
        }); */
                pickr.on("save", (color, instance) => {
                    let colorString;
                    switch (format) {
                        case "HEXA":
                            colorString = color.toHEXA().toString();
                            break;
                        case "RGBA":
                            colorString = color.toRGBA().toString();
                            break;
                        case "HSVA":
                            colorString = color.toHSVA().toString();
                            break;
                        default:
                            colorString = color.toHEXA().toString();
                    }
                    onColorChange && onColorChange(colorString);
                    copyToClipboard(colorString);
                    setShowMessage(true);
                    setTimeout(() => setShowMessage(false), 2000); // Скрыть сообщение через 2 секунды
                    /* pickr.hide(); */
                });

                return () => pickr.destroy();
            }
        });
    }, [onColorChange, format]);

    const copyToClipboard = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                console.log("Color copied to clipboard!");
            })
            .catch((err) => {
                console.error("Failed to copy color to clipboard!", err);
            });
    };

    return (
        <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            <div ref={pickrContainer}></div>
            {showMessage && (
                <div
                    style={{
                        position: "fixed",
                        top: "10px",
                        right: "10px",
                        backgroundColor: "rgba(0,0,0,0.7)",
                        color: "white",
                        padding: "10px",
                        borderRadius: "5px",
                    }}
                >
                    {titleCopied}
                </div>
            )}
        </div>
    );
}

export default ColorPicker;
